import "./UserShortProfile.css";
import { MdLocationOn,  MdOutlineCloudUpload} from "react-icons/md";
import { useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import DefaultImage from "../../medias/images/default.jpg"
import { updateUserPhotoRequest } from "../../services/wisdomServices/userService.js";
import { requestGetImagesFromBucket } from "../../services/wisdomServices/trackingService.js";
import { getSessionItem, setSessionItem } from "../../utils/helper/session.js";
import { Button } from "primereact/button";
import { Tag } from "primereact/tag";
import { IdvStatus } from "../idvStatus/IdvStatus.jsx";
import { Can } from "../../security/Can.jsx";
import { PERMISSIONS } from "../../security/permissions.generated.js";
import { NavLink } from "react-router-dom";
/**
 * @function UserShortProfile
 * @param {Object} props
 * @param {string} props.employeePicture - current profile picture filename
 * @param {string} props.employeeUsername - employee email/username
 * @param {string|Date} props.employeeContractEndDate - contract end date
 * @param {boolean} props.employeeDisabled - indicates if employee is disabled
 */
function UserShortProfile(props) {
  const toast = useRef(null)
  const [currentProfileImage, setCurrentProfileImage] = useState(props.employeePicture)
  const [imageBase64, setImageBase64] = useState('')
  const [userId, setUserId] = useState()
  const [user, setUser] = useState()
  const [loaded, setLoaded] = useState(false)
  const [showIcon, setShowIcon] = useState(false);
  const [offboardingUrl, setOffboardingUrl] = useState('')
  const [renewContract, setRenewContract] = useState('')
  const [disabled, setDisabled] = useState('')
  const [chatUrl, setChatUrl] = useState('')
  
  useEffect(() => {
    let user = getSessionItem("User")
    setUser(user)
    setUserId(user.id)
    let username = props.employeeUsername.split('@')[0]
    setChatUrl(`https://chat.sirius-support.com/direct/${username}`)
    setOffboardingUrl(`https://sirius-support.atlassian.net/servicedesk/customer/portal/6/group/20/create/85?customfield_10081=${username}`)
    let checkContractEndDate = validateContractDate(props.employeeContractEndDate)
    if(checkContractEndDate){
      setRenewContract(`https://sirius-support.atlassian.net/servicedesk/customer/portal/6/group/20/create/108?customfield_10081=${props.employeePersonalEmail}&customfield_10176=${user.email}`)
    }
    let isUserDisabled = props.employeeDisabled === true ? 'Disabled' : 'Active'
    setDisabled(isUserDisabled)
    setLoaded(true)
  }, [])

  const closeModal = () => {
    let modal = document.getElementById('upload-modal')
    modal.setAttribute('class', 'disable')
  }

  const validateContractDate = (employeeContractEndDate) => {
    // Parse the employee contract end date
    const endDate = new Date(employeeContractEndDate);
    
    // Get today's date
    const today = new Date();
    
    // Calculate the difference in time (milliseconds)
    const timeDifference = endDate - today;
    
    // Convert the difference from milliseconds to days
    const daysDifference = timeDifference / (1000 * 60 * 60 * 24);
    
    // Check if the difference is 30 days or less
    return daysDifference <= 30;
  }

  const openModal = () => {
    let modal = document.getElementById('upload-modal')
    modal.setAttribute('class', 'able')
  }

  const showWarning = (text) => {
    toast.current.show({severity:'warning', summary: 'Warning', detail:text, life: 3000});
  }

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    
    if (file && (file.type == 'image/jpeg' || file.type == 'image/png')) {
      const reader = new FileReader();
      reader.onloadend = () => {
        let base64 = reader.result.split(',')
        setImageBase64(base64[1]);
      };
      reader.readAsDataURL(file);
    } else {
      showWarning('Please, select an JPEG or PNG file.');
    }
  };

  const uploadPicture = async () => {
    if (!imageBase64) {
      const confirmed = window.confirm("The image will be reset, are you sure?");
      if (!confirmed) return;
    }
  
    let key = {
      imageBase64: imageBase64
    };
    try {
      let upload = await updateUserPhotoRequest(userId, key)
      let img = upload === null ? DefaultImage : upload;
    
      user.image = img;
      setSessionItem("User", user);
    
      getUserProfileImage(img);
      window.location.reload();
      closeModal();
      
    } catch (error) {
      console.error(error)
    }
  };

  const getUserProfileImage = async(imageName) => {
    const blob = await requestGetImagesFromBucket(user.id, imageName, "profile")
    let img = URL.createObjectURL(blob)
    setCurrentProfileImage(img)
  }


  return (
    <>
      <Toast ref={toast} position="top-center" />

      {loaded && (
        <div className="user-short-profile">
          <div className="EmployeeShortProfile">
            <div
              className="image-box"
              onMouseEnter={() => setShowIcon(true)}
              onMouseLeave={() => setShowIcon(false)}
            >
              <img
                className="summaryProfileImage"
                src={currentProfileImage}
                alt=""
              />

              {showIcon && user.id == props.employeeID && (
                <div className="icone-cloud-upload">
                  <MdOutlineCloudUpload onClick={openModal} />
                </div>
              )}
            </div>

            <div className="summaryProfileInformation">
              <div className="manager-view-user-short-profile">
                <p className="manager-view-user-short-profile-name">
                  {props.employeeName}
                </p>

                <p className="manager-view-user-short-profile-pronoun">
                  {" (" + props.employeePronoun + ")"}
                </p>

                <IdvStatus status={props.employeeIdvStatus} />
              </div>

              <span className="summaryProfile-designation">
                {props.employeeDepartment} - {props.employeeDesignation}
              </span>

              <span className="summaryProfile-ID">
                Employee ID: {props.employeeID}
              </span>

              <span className="summaryProfile-status">
                {props.employeeUsername}
              </span>

              <span className="summaryProfile-location">
                <MdLocationOn />
                {props.employeeLocation}
              </span>

              <div className="user-status-box">
                <span className="summaryProfile-disabled">
                  Status: {disabled}
                </span>

                {props.employeeDisabled === false && (
                  <div className="user-status-btns">
                    <Button
                      link
                      onClick={() => window.open(offboardingUrl, "_blank")}
                      label="Offboard User"
                      icon="pi pi-user-minus"
                      style={{ color: "#EF4444" }}
                    />

                    {renewContract !== "" && (
                      <Button
                        link
                        onClick={() => window.open(renewContract, "_blank")}
                        label="Renew Contract"
                        icon="pi pi-refresh"
                        style={{ color: "#F97316" }}
                      />
                    )}

                    <Button
                      link
                      onClick={() => window.open(chatUrl, "_blank")}
                      label="Send Chat"
                      icon="pi pi-comments"
                      style={{ color: "#0EA5E9" }}
                    />
                  </div>
                )}
              </div>
            </div>

            <div className="upload-modal disable" id="upload-modal">
              <div className="modal-content">
                <h3>Upload Profile Picture</h3>

                <div className="modal-inputs">
                  {currentProfileImage && (
                    <img
                      className="uploaded-image"
                      src={currentProfileImage}
                      alt="current user profile"
                    />
                  )}

                  <div className="modal-form">
                    <input
                      className="upload-picture"
                      type="file"
                      id="upload-input"
                      name="upload-input"
                      accept="image/png, image/jpeg"
                      width="200px"
                      height="200px"
                      onChange={handleFileChange}
                    />

                    <div className="modal-btns">
                      <Can permission={PERMISSIONS.usersByIdPhoto_patch}>
                        <Button
                          label="Save"
                          icon="pi pi-upload"
                          severity="success"
                          onClick={uploadPicture}
                        />
                      </Can>

                      <Button
                        label="Close"
                        icon="pi pi-times"
                        severity="warning"
                        onClick={closeModal}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {props.showManagerLinks && (
            <nav className="user-short-profile__nav">
              <ul className="user-short-profile__nav-list">
                <li className="user-short-profile__nav-item">
                  <NavLink
                    className={({ isActive }) =>
                      `user-short-profile__nav-link${isActive ? " active" : ""}`
                    }
                    to={`/manager/summary/${props.employeeID}`}
                  >
                    Summary
                  </NavLink>
                </li>

                <li className="user-short-profile__nav-item">
                  <NavLink
                    className={({ isActive }) =>
                      `user-short-profile__nav-link${isActive ? " active" : ""}`
                    }
                    to={`/manager/personalInfo/${props.employeeID}`}
                  >
                    Personal Info
                  </NavLink>
                </li>

                <li className="user-short-profile__nav-item">
                  <NavLink
                    className={({ isActive }) =>
                      `user-short-profile__nav-link${isActive ? " active" : ""}`
                    }
                    to={`/manager/diary/${props.employeeID}`}
                  >
                    Diary
                  </NavLink>
                </li>

                <li className="user-short-profile__nav-item">
                  <NavLink
                    className={({ isActive }) =>
                      `user-short-profile__nav-link${isActive ? " active" : ""}`
                    }
                    to={`/manager/user-requests/${props.employeeID}`}
                  >
                    Requests
                  </NavLink>
                </li>

                <li className="user-short-profile__nav-item">
                  <NavLink
                    className={({ isActive }) =>
                      `user-short-profile__nav-link${isActive ? " active" : ""}`
                    }
                    to={`/manager/compliance/${props.employeeID}`}
                  >
                    Compliance
                  </NavLink>
                </li>

                <li className="user-short-profile__nav-item">
                  <NavLink
                    className={({ isActive }) =>
                      `user-short-profile__nav-link${isActive ? " active" : ""}`
                    }
                    to={`/manager/coaching/${props.employeeID}`}
                  >
                    Growth Management
                  </NavLink>
                </li>

                <li className="user-short-profile__nav-item">
                  <NavLink
                    className={({ isActive }) =>
                      `user-short-profile__nav-link${isActive ? " active" : ""}`
                    }
                    to={`/manager/blockers/${props.employeeID}`}
                  >
                    Blockers
                  </NavLink>
                </li>
              </ul>
            </nav>
          )}
        </div>
      )}
    </>
  );
}

export default UserShortProfile;
